<template>
<div>
        <div class="subulei column">
        <h1>苏布雷水电站GNSS监测系统</h1>
        <div class="projectintro_box">
           <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>项目基本情况</h6>
           </div>
           <p>1、项目位于科特迪瓦苏布雷市西5Km处     </p>
           <p>2、坝体全长4.6Km</p>
           <p>3、在取水口及溢洪道处稳定的结构物上分别设置参考站</p>
           <p>4、在坝体上重点监测区域分布 了9个监测站</p>
           <p>5、每个站点通过独产的4芯光纤汇集到取水口监测房，然后通过48芯光纤与监测室服务器相连接</p>
           <img src="../../assets/su/1.jpg" alt="" class="normal">
            <h3>项目建设内容分为6个子系统：</h3>
            <p>1、项目位于科特迪瓦苏布雷市西5Km处 </p>
            <p>2、坝体全长4.6Km</p>
            <p>3、在取水口及溢洪道处稳定的结构物上分别设置参考站</p>
            <p>4、在坝体上重点监测区域分布 了9个监测站</p>
            <p>5、每个站点通过独产的4芯光纤汇集到取水口监测房，然后通过48芯光纤与监测室服务器相连接</p>
            <img src="../../assets/su/2.jpg" alt="" class="normal">
            <img src="../../assets/su/3.jpg" alt="" class="bigger">
              <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>监测系统设备简介</h6>

           </div>
            <h3 style="padding-top:0.15rem">监测站整体结构由4大部分组成 </h3>
              <p>1、基础及观测墩      3、为了保证防雷，接地地网位于坝体坡脚排水渠外 </p>
              <p>2、避雷针及接地地网</p>
              <p>3、监测设备机箱</p>
              <p>4、监测天线及保护罩</p>
              <p> &nbsp1、基础采用扩大基础混凝土浇筑承台，尺寸60CM*60 CM，预留观测墩焊接钢板</p>
              <p> &nbsp2、观测墩采用镀锌钢材料，顶部预制强制对中盘，并预留天线电缆孔、供电孔、光纤进口及天线罩安装套件及天线加长杆。</p>
              <p>3、经过调平后观测墩与基础进行焊接并浇筑观测墩底座</p>
              <p> &nbsp1、避雷针采用与观测墩等高度镀锌钢管支撑</p>
              <p> &nbsp2、接地部分采用铜缆与地网相连接</p>
              <img src="../../assets/su/4.jpg" alt="" class="normal">
              <h3 >监测站整体结构由4大部分组成 </h3>
              <p>1、基础及观测墩</p>
              <p>2、避雷针及接地地网</p>
              <p>3、监测设备机箱</p>
              <p>4、监测天线及保护罩</p>
              <p>1、基础采用扩大基础混凝土浇筑承台，尺寸60CM*60 CM，预留观测墩焊接钢板</p>
              <p>2、观测墩采用镀锌钢材料，顶部预制强制对中盘，并预留天线电缆孔、供电孔、光纤进口及天线罩安装套件及天线加长杆。</p>
              <p>3、经过调平后观测墩与基础进行焊接并浇筑观测墩底座</p>
              <p>1、避雷针采用与观测墩等高度镀锌钢管支撑</p>
              <p>2、接地部分采用铜缆与地网相连接</p>
              <p>3、为了保证防雷，接地地网位于坝体坡脚排水渠外 </p>
              <img src="../../assets/su/5.jpg" alt="" class="best">
                 <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>安装调试情况</h6>
           </div>
            
              <h3>安装工具介绍 </h3>
              <p>机箱组装 天线安装 避雷系统施工 机箱支架焊接 机箱安装--》机箱结构设计图 光纤接入--》接线一览表 调试软件介绍（了解） 网络调试--》常用命令、软件等 静态观测--》初始<br>位置确定、搜星情况分析、相关软件 </p>
              <div class="imgbox row">
                  <img src="../../assets/su/6.jpg" alt="" class="mini">
                  <img src="../../assets/su/7.jpg" alt="" class="mini">
                  <img src="../../assets/su/8.jpg" alt="" class="mini">
              </div>
              <img src="../../assets/su/9.jpg" alt="" class="normal">
        </div>
        <foot></foot>
    </div>

</div>

</template>

<style>
.subulei {
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
}
.subulei h1 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
  text-align: center;
}
.projectintro_box h6 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(37, 43, 58, 1);
}
.projectintro_box p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-top: 0.1rem;
}
.projectintro_box h3 {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  color: rgba(37, 43, 58, 1);
}
.subulei .axis {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
.subulei .projectintro_box {
  width: 11.2rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  margin-bottom: .67rem;
}
.subulei .basic_title {
  margin-top: 0.34rem;
  margin-bottom: 0.04rem;
}
.subulei .normal {
  width: 9.6rem;
  height: 5.4rem;
  margin-top: 0.2rem;
}
.subulei .bigger {
  width: 9.64rem;
  height: 6.31rem;
  margin-top: 0.1rem;
}
.subulei .best {
  width: 9.62rem;
  height: 6.9rem;
  margin-top: .2rem;
}
.subulei .imgbox{
    width: 9.62rem;
    justify-content: space-between;
    margin-top: .26rem;

}
.subulei .mini {
  width: 3.07rem;
  height: 1.73rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/casepage/subulei.vue